import {InlineImageComponent} from './InlineImageComponent'

const InlineImagePackage = {
    name: 'UIInlineImage',
    configure: function(config) {
        config.addComponent('UIInlineImage', InlineImageComponent, false, 'InlineImageComponent')
    }
}

export {InlineImagePackage}
